import { useQuery } from '@tanstack/react-query';
import { api } from '../services/api';
import { getAppLanguage } from '../utils/i18nSync';

interface AssessmentTranslation {
  questions: string[];
  options: string[];
}

export function useAssessmentTranslations(assessmentType: 'phq9' | 'gad7', enabled: boolean) {
  const language = getAppLanguage();

  return useQuery({
    queryKey: ['assessment-translations', assessmentType, language],
    queryFn: () => api.get<AssessmentTranslation>(`/translations/${assessmentType}/${language}`),
    enabled,
    staleTime: 24 * 60 * 60 * 1000,
  });
}
